var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-row',[_c('b-col',{staticClass:"mt-5",attrs:{"align":"center"}},[_c('b',[_vm._v("This is a system dashboard example.")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }